import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ApiService } from '@env-lib/api/api.service'
import { FleetMileageStatusResponseBody } from '@fleet-lib/mileage/fleet-mileage.model'
import { map } from 'rxjs/operators'

@Injectable({
    providedIn: 'root',
})
export class FleetMileageWidgetService {
    constructor(
        private api: ApiService,
        private http: HttpClient
    ) {}

    getMileageStatusSummary() {
        const url = `${this.api.fleet.backendUrl}/fleet/mileage/status`

        return this.http
            .get<FleetMileageStatusResponseBody>(url)
            .pipe(map((response) => response.status))
    }
}
